var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle } from '../../helpers/styles';
var StyledVideoViewer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
});
var VideoViewer = function (props) {
    var identifier = props.identifier, type = props.type;
    var stateFromEnv = useContext(WindowStateContext);
    var _onLabelClick = useContext(WindowEventContext)._onLabelClick;
    var geometry = props.attributes.geometry || {};
    var handleClick = function () {
        if (!resource) {
            _onLabelClick(identifier);
        }
    };
    var resource = stateFromEnv.fields[identifier];
    return (React.createElement(StyledVideoViewer, { id: identifier, "data-widget-type": type, geometry: geometry, onClick: handleClick },
        React.createElement("video", { key: resource, width: geometry.width, height: geometry.height, controls: true, autoPlay: true },
            React.createElement("source", { src: resource, type: "video/mp4" }))));
};
export default VideoViewer;
var templateObject_1;
//# sourceMappingURL=index.js.map